import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const deleteTaskType = (
    token: string,
    backend: string,
    id: string,
) => {
    return fetch(
        `${getApiUrl(backend)}tasktypes/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteTaskType